module.exports = __webpack_public_path__ + "img/t_0039.d93b3efb.gif";